import { FormEvent, useState } from 'react';
import { Alert, Box, Button, CircularProgress, Paper, Stack, TextField, Typography } from '@mui/material';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import AuthController from '../../Api/authController';
import { useUser } from '../../hooks/useUser';

const ChangePasswordPage = () => {
    const user = useUser();
    const navigate = useNavigate();
    const location = useLocation();
    const loginPath = location.state?.returnTo === '/awizacje' ? '/awizacje' : '/logowanie';
    const [currentPassword, setCurrentPassword] = useState('');
    const [password, setPassword] = useState('');
    const [repeat, setRepeat] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    if (!user.authReady) return <Box minHeight="100vh" display="grid" sx={{ placeItems: 'center' }}><CircularProgress /></Box>;
    if (!user.currentUser) return <Navigate to={loginPath} replace />;
    const submit = async (event: FormEvent) => {
        event.preventDefault();
        if (password !== repeat) return setError('Hasla nie sa identyczne');
        setLoading(true); setError('');
        try { await AuthController.changePassword(currentPassword, password); await user.logout(); navigate(loginPath, { replace: true }); }
        catch (err: any) { setError(err?.response?.data?.message || 'Nie udalo sie zmienic hasla'); }
        finally { setLoading(false); }
    };
    return <Box minHeight="100vh" display="grid" sx={{ placeItems: 'center', bgcolor: '#f4f6fb', p: 2 }}><Paper component="form" onSubmit={submit} sx={{ p: 4, width: '100%', maxWidth: 460 }}><Stack spacing={2}>
        <Typography variant="h5" fontWeight={800}>Zmiana hasla</Typography>
        {user.currentUser.mustChangePassword && <Alert severity="warning">Przed dalsza praca ustaw wlasne haslo.</Alert>}
        {error && <Alert severity="error">{error}</Alert>}
        <TextField label="Obecne haslo" type="password" value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} required />
        <TextField label="Nowe haslo" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required helperText="Min. 10 znakow, mala i wielka litera oraz cyfra" />
        <TextField label="Powtorz nowe haslo" type="password" value={repeat} onChange={(e) => setRepeat(e.target.value)} required />
        <Button type="submit" variant="contained" disabled={loading}>{loading ? 'Zapisywanie...' : 'Zmien haslo'}</Button>
    </Stack></Paper></Box>;
};
export default ChangePasswordPage;
